import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {apiGetInputProgram} from 'constants/Api';

import {
  // already exists in actions.ts
  reduxSetCreateProgram, // already exists in actions.ts
} from 'appredux/actions';

import ProgramCreate from './ProgramCreate';
import {RootState} from 'appredux/reducers';

import {
  IFarmInputProgram, // full API shape
  IFarmInputProgramInput, // draft/input shape
  IFarmInputProgramLineInput,
  IProductDetails,
} from 'constants/interfaces';

/* ---------- helper: convert API shape → input shape ---------- */
function toInputShape(prog: IFarmInputProgram): IFarmInputProgramInput {
  const convertedLines: IFarmInputProgramLineInput[] = (prog.lines || []).map(
    (line) => ({
      ...line,
      // API returns string; input shape expects number
      applicationTypePerHectare: Number(line.applicationTypePerHectare) || 0,
      // Convert IFarmInputProduct to IProductDetails-compatible shape
      product: line.product
        ? ({
            id: line.product.id,
            name: line.product.name,
            price: line.product.price,
            category: line.product.category,
            stockCode: line.product.stockCode,
            size: line.product.size,
            measurement: line.product.measurement,
            productType: line.product.productType,
            lastUpdated: new Date(),
            date: new Date(),
            activeIngredient: line.product.activeIngredient || '',
            tradeName: line.product.tradeName,
            bugs: line.product.bugs?.map((bug) => bug.name).join(', ') || '',
          } as IProductDetails)
        : undefined,
    }),
  );

  return {
    ...prog,
    lines: convertedLines,
  };
}

export default function ProgramPage() {
  const {id} = useParams<{id?: string}>();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(!!id);

  /* ----- Redux slices ProgramCreate expects ----- */
  const user = useSelector((s: RootState) => {
    return s.user;
  });
  const productState = useSelector((s: RootState) => s.products);
  const createProgramState = useSelector((s: RootState) => s.createProgram);
  /* ----- fetch / reset logic ----- */
  useEffect(() => {
    if (!id) {
      // CREATE MODE → blank draft
      // dispatch(reduxClearCreateProgram());
      return;
    }

    // VIEW / EDIT MODE → fetch single program
    setLoading(true);
    apiGetInputProgram(id)
      .then((prog) => dispatch(reduxSetCreateProgram(toInputShape(prog))))
      .finally(() => setLoading(false));
  }, [id, dispatch]);

  if (loading) {
    return <p style={{padding: 24}}>Loading program…</p>;
  }

  /* ----- render presentational component ----- */
  return (
    <ProgramCreate
      user={user}
      productState={productState}
      createProgramState={createProgramState}
    />
  );
}
